import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { TournamentMatchGameEntity } from 'app/interfaces/entity';
import { AppState } from 'app/interfaces/store';

import { CurrentTournamentMatchGameState } from './interfaces';

const currentTournamentMatchGameState = (state: AppState): CurrentTournamentMatchGameState =>
  state[EntityStoreName.CurrentTournamentMatchGame];

const matchGameSelector = createSelector(
  currentTournamentMatchGameState,
  (state: CurrentTournamentMatchGameState) => state.entity as TournamentMatchGameEntity
);

export const currentTournamentMatchGameSelector = {
  matchGame: matchGameSelector,
};
